// Prompt 0457 T-3 — Iconos SVG del FichaToolbar extraidos a un modulo propio.
// Trazo 2px, 12x12, estilo minimalista. Todos los iconos aceptan herencia de
// color via `currentColor` (el boton padre del toolbar define el stroke por
// estado activo/inactivo).

import type React from 'react';

const SVG_PROPS: React.SVGProps<SVGSVGElement> = {
  width: 12,
  height: 12,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
};

export function IconBold() {
  return (
    <svg {...SVG_PROPS} strokeWidth={3} strokeLinejoin="round">
      <path d="M6 4h8a4 4 0 014 4 4 4 0 01-4 4H6z" />
      <path d="M6 12h9a4 4 0 014 4 4 4 0 01-4 4H6z" />
    </svg>
  );
}

export function IconItalic() {
  return (
    <svg {...SVG_PROPS}>
      <line x1="19" y1="4" x2="10" y2="4" />
      <line x1="14" y1="20" x2="5" y2="20" />
      <line x1="15" y1="4" x2="9" y2="20" />
    </svg>
  );
}

export function IconUnderline() {
  return (
    <svg {...SVG_PROPS}>
      <path d="M6 3v7a6 6 0 0012 0V3" />
      <line x1="4" y1="21" x2="20" y2="21" />
    </svg>
  );
}

export function IconBullet() {
  return (
    <svg {...SVG_PROPS}>
      <line x1="8" y1="6" x2="21" y2="6" />
      <line x1="8" y1="12" x2="21" y2="12" />
      <line x1="8" y1="18" x2="21" y2="18" />
      <circle cx="4" cy="6" r="1" fill="currentColor" />
      <circle cx="4" cy="12" r="1" fill="currentColor" />
      <circle cx="4" cy="18" r="1" fill="currentColor" />
    </svg>
  );
}

export function IconOrdered() {
  return (
    <svg {...SVG_PROPS}>
      <line x1="10" y1="6" x2="21" y2="6" />
      <line x1="10" y1="12" x2="21" y2="12" />
      <line x1="10" y1="18" x2="21" y2="18" />
      <path d="M4 6h1v4" />
      <path d="M4 10h2" />
      <path d="M6 18H4c0-1 2-2 2-3s-1-1.5-2-1" />
    </svg>
  );
}

export function IconQuote() {
  return (
    <svg {...SVG_PROPS}>
      <path d="M3 7h6v6H5c0 2 1 4 3 4" />
      <path d="M13 7h6v6h-4c0 2 1 4 3 4" />
    </svg>
  );
}

export function IconAlign({ dir }: { dir: 'left' | 'center' | 'right' }) {
  const lines: Array<[number, number]> =
    dir === 'left'
      ? [
          [3, 15],
          [3, 10],
          [3, 15],
          [3, 12],
        ]
      : dir === 'center'
        ? [
            [5, 19],
            [7, 17],
            [4, 20],
            [6, 18],
          ]
        : [
            [9, 21],
            [14, 21],
            [9, 21],
            [12, 21],
          ];
  return (
    <svg {...SVG_PROPS}>
      <line x1={lines[0][0]} y1="6" x2={lines[0][1]} y2="6" />
      <line x1={lines[1][0]} y1="10" x2={lines[1][1]} y2="10" />
      <line x1={lines[2][0]} y1="14" x2={lines[2][1]} y2="14" />
      <line x1={lines[3][0]} y1="18" x2={lines[3][1]} y2="18" />
    </svg>
  );
}

export function IconClear() {
  return (
    <svg {...SVG_PROPS}>
      <path d="M3 7l7 7" />
      <path d="M14 3h7l-8 14" />
      <line x1="5" y1="20" x2="20" y2="20" />
      <line x1="3" y1="3" x2="21" y2="21" />
    </svg>
  );
}

export function IconUndo() {
  return (
    <svg {...SVG_PROPS} strokeLinejoin="round">
      <polyline points="3 7 3 13 9 13" />
      <path d="M3 13a9 9 0 1116-5" />
    </svg>
  );
}

export function IconRedo() {
  return (
    <svg {...SVG_PROPS} strokeLinejoin="round">
      <polyline points="21 7 21 13 15 13" />
      <path d="M21 13a9 9 0 10-16-5" />
    </svg>
  );
}
